import addBlockCommands from './block';
import addComponentCommands from './component';
import addEditorCommands from './editor';
import addSelectionCommands from './selection';
import addStorageCommands from './storage';
import addStyleCommands from './style';
import addWalkthroughCommands from './walkthrough';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';

/**
 * Initialize listeners for the editor
 */
export default (opt: PrimaryConfigOptions): void => {
  addBlockCommands(opt);
  addComponentCommands(opt);
  addEditorCommands(opt);
  addSelectionCommands(opt);
  addStorageCommands(opt);
  addStyleCommands(opt);
  addWalkthroughCommands(opt);
};
